import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { PaymentService } from '../shared/services/payment.service';
import { CustomQueryEncoderHelper } from '../shared/CustomQueryEncoderHelper';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../shared/services/payment.service";
var AccountSettingsService = /** @class */ (function () {
    function AccountSettingsService(http, paymentService) {
        this.http = http;
        this.paymentService = paymentService;
    }
    AccountSettingsService.prototype.getNotificationSettings = function () {
        return this.http.get('/settings/notifications');
    };
    AccountSettingsService.prototype.saveNotifications = function (_a) {
        var lowBalanceEnabled = _a.lowBalanceEnabled, lowBalanceThreshold = _a.lowBalanceThreshold, email = _a.email;
        return this.http.post('/settings/notifications', {
            autoRechargeEnabled: true,
            lowBalanceEnabled: lowBalanceEnabled,
            lowBalanceThreshold: lowBalanceThreshold,
            email: email
        });
    };
    AccountSettingsService.prototype.getAutoRechargeSettings = function () {
        return this.http.get('/finance/charges/recharge');
    };
    AccountSettingsService.prototype.chargeImmediately = function (_a) {
        var amount = _a.amount;
        return this.http.post('/finance/charges', {
            amount: amount
        });
    };
    AccountSettingsService.prototype.saveAutoRecharge = function (_a) {
        var enabled = _a.enabled, amount = _a.amount, threshold = _a.threshold;
        return this.http.post('/finance/charges/recharge', {
            enabled: enabled,
            amount: amount,
            threshold: 10
        });
    };
    AccountSettingsService.prototype.getBalance = function () {
        var params = new HttpParams({ encoder: new CustomQueryEncoderHelper() });
        params = params.set('dateFrom', moment()
            .startOf('day')
            .format());
        return this.http.get('/finance/balance', {
            params: params
        });
    };
    AccountSettingsService.prototype.getPackagePlans = function () {
        return this.http.get('/finance/plans/package');
    };
    AccountSettingsService.prototype.getPlans = function () {
        return this.http.get('/finance/plans');
    };
    AccountSettingsService.prototype.getAddons = function () {
        return this.http.get('/finance/addons');
    };
    AccountSettingsService.prototype.getSubscription = function () {
        return this.http.get('/finance/license-subscription');
    };
    AccountSettingsService.prototype.currentPlan = function () {
        return this.http.get('/finance/current-plan');
    };
    AccountSettingsService.prototype.getChangeSubscriptionLimits = function (planId) {
        return this.http.get("/finance/plans/" + planId + "/limits");
    };
    AccountSettingsService.prototype.getCard = function () {
        return this.http.get('/finance/card');
    };
    AccountSettingsService.prototype.getCardMetadata = function () {
        return this.http.get('/finance/card/metadata');
    };
    AccountSettingsService.prototype.getMsisdnsSubscriptions = function () {
        return this.http.get('/msisdns/occupied');
    };
    AccountSettingsService.prototype.getMsisdns = function () {
        return this.http.get('/msisdns');
    };
    AccountSettingsService.prototype.submitSubscription = function (_a) {
        var _this = this;
        var planId = _a.planId, quantity = _a.quantity;
        var originState = 'my-account';
        this.paymentService.onSpinnerActivate(true);
        this.http
            .post('/finance/subscription/', {
            planId: planId,
            quantity: quantity
        })
            .subscribe(function (v) { return _this.paymentService.handleSubscriptionPayment(v, originState); }, function () {
            _this.paymentService.redirect(originState);
            _this.paymentService.onSpinnerActivate(false);
        });
    };
    AccountSettingsService.prototype.changeCard = function () {
        var _this = this;
        var originState = 'a';
        this.http.post('/finance/card/', {}).subscribe(function (v) { return _this.paymentService.handleSubscriptionPayment(v, originState); }, function () {
            _this.paymentService.redirect(originState);
            _this.paymentService.onSpinnerActivate(false);
        });
    };
    AccountSettingsService.prototype.getAllButAdministrativeUsers = function () {
        return this.http.get('/users');
    };
    AccountSettingsService.prototype.updateUsersLimit = function (data) {
        return this.http.put('/users/update-statuses', data);
    };
    AccountSettingsService.prototype.isDetachableNumber = function (id) {
        return this.http.get("/msisdns/" + id + "/can-be-detached");
    };
    AccountSettingsService.prototype.detachNumber = function (id) {
        return this.http.put("/msisdns/" + id + "/detach", {});
    };
    AccountSettingsService.ngInjectableDef = i0.defineInjectable({ factory: function AccountSettingsService_Factory() { return new AccountSettingsService(i0.inject(i1.HttpClient), i0.inject(i2.PaymentService)); }, token: AccountSettingsService, providedIn: "root" });
    return AccountSettingsService;
}());
export { AccountSettingsService };
